import { useCallback } from 'react'
import { useIntl } from 'react-intl'

function useCarHireFuelPolicyLabel() {
  const intl = useIntl()

  return useCallback((fuelPolicy?: string): string | undefined => {
    switch (fuelPolicy) {
      case 'Return with a full tank of fuel.':
        return intl.formatMessage({
          id: 'Hri9rcep2_AuZp0K8Tfv',
          defaultMessage: 'Return with a full tank of fuel.',
          description: 'Car hire fuel policy telling customers to return the vehicle with a full tank of fuel',
        })
      case 'No refuelling required before return.':
        return intl.formatMessage({
          id: 'umjll-e5Z-fMMF5g2kFR',
          defaultMessage: 'No refuelling required before return.',
          description: 'Car hire fuel policy telling customers that no refuelling is required before returning the vehicle',
        })
      case 'Pre-purchase fuel. No refuelling required before return.':
        return intl.formatMessage({
          id: 'CuXTqoBC8CFy_jTaDErB',
          defaultMessage: 'Pre-purchase fuel. No refuelling required before return.',
          description: 'Car hire fuel policy telling customers to pre-purchase fuel and that no refuelling is required before return',
        })
      case 'Return with a quarter tank of fuel.':
        return intl.formatMessage({
          id: 'uGZExk3v23Lx5Piv4Tnd',
          defaultMessage: 'Return with a quarter tank of fuel.',
          description: 'Car hire fuel policy telling customers to return the vehicle with a quarter tank of fuel',
        })
      case 'Return with half a tank of fuel.':
        return intl.formatMessage({
          id: '_DdpmRVtI5HQXctNLztO',
          defaultMessage: 'Return with half a tank of fuel.',
          description: 'Car hire fuel policy telling customers to return the vehicle with half a tank of fuel',
        })
      case 'Free tank of fuel included':
        return intl.formatMessage({
          id: 'ztaq3ZCPfU_6r8V2VC0I',
          defaultMessage: 'Free tank of fuel included',
          description: 'Car hire fuel policy telling customers that a free tank of fuel is included',
        })
      case 'If fuel tank is returned with remaining fuel, you will be refunded for the fuel you did not use':
        return intl.formatMessage({
          id: 'Ap6SZRnwzodcPh46kpJm',
          defaultMessage: 'If fuel tank is returned with remaining fuel, you will be refunded for the fuel you did not use',
          description: 'Car hire fuel policy telling customers they will be refunded for unused fuel when returning the car',
        })
      case 'Return with a full tank of fuel':
        return intl.formatMessage({
          id: 'KQl67ejN2cIHSJm6aC4z',
          defaultMessage: 'Return with a full tank of fuel',
          description: 'Car hire fuel policy telling customers to return the vehicle with a full tank of fuel without terminal punctuation',
        })
      case 'Chauffer included. Must be returned with a full tank of fuel':
        return intl.formatMessage({
          id: '18DR63yEkUy8d6pVvHey',
          defaultMessage: 'Chauffer included. Must be returned with a full tank of fuel',
          description: 'Car hire fuel policy telling customers that a chauffeur is included and the car must be returned with a full tank',
        })
      case 'Return with same charge level as pick-up.':
        return intl.formatMessage({
          id: 'SRW3NLn8mZJARSkZbpCh',
          defaultMessage: 'Return with same charge level as pick-up.',
          description: 'Car hire fuel policy telling customers to return an electric vehicle with the same charge level as pickup',
        })
      default:
        return fuelPolicy
    }
  }, [intl])
}

export default useCarHireFuelPolicyLabel
